import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';

import MuiSelect from '@mui/material/Select';

import { getDropdownMenuWidth, getDropdownMenuWidthStyles } from '~/utils/dropdown-menu';

/**
 * Shared low-level select for compact or specialized controls such as editable table cells.
 * Standard form fields use OlcDropdownSearch; multi-value fields use MultiSelectNew.
 */
const OlcSelect = forwardRef(({ MenuProps = {}, onOpen, ...props }, forwardedRef) => {
  const selectRef = useRef(null);
  const [menuWidth, setMenuWidth] = useState(null);

  useImperativeHandle(forwardedRef, () => selectRef.current);

  const handleOpen = (event) => {
    setMenuWidth(getDropdownMenuWidth(selectRef.current));
    onOpen?.(event);
  };

  return (
    <MuiSelect
      {...props}
      ref={selectRef}
      onOpen={handleOpen}
      MenuProps={{
        ...MenuProps,
        disableScrollLock: MenuProps.disableScrollLock ?? true,
        PaperProps: {
          ...MenuProps.PaperProps,
          style: {
            ...MenuProps.PaperProps?.style,
            ...getDropdownMenuWidthStyles(menuWidth),
            overflow: 'hidden',
          },
        },
        MenuListProps: {
          ...MenuProps.MenuListProps,
          style: {
            maxHeight: 224,
            overflowY: 'auto',
            ...MenuProps.MenuListProps?.style,
          },
        },
      }}
    />
  );
});

OlcSelect.displayName = 'OlcSelect';

export default OlcSelect;
